import { toGoogleCoordinates } from 'shared/helpers/coordinates';

export default (homes = []) =>
  homes.map(
    ({
      identifiantImmeuble: id,
      numeroVoieImmeuble: number,
      complementNumeroVoieImmeuble: numberExtra = '',
      typeVoieImmeuble: roadType,
      nomVoieImmeuble: roadName,
      communeImmeuble: city,
      etatImmeuble: state,
      latitude,
      longitude
    }) => ({
      id,
      state,
      position: toGoogleCoordinates({ latitude, longitude }),
      address: {
        number,
        numberExtra,
        roadType,
        roadName,
        city
      }
    })
  );
